// import dashBoard from "@/api/dashBoard";
// import { formatISO,getLocalDate } from '@/utils/date-helpers';
// const fromDate=formatISO( new Date(new Date().setHours(0,0,0,0)));
// const toDate= formatISO(new Date(new Date().setHours(23,59,0,0)))
// const fromRosterDate= getLocalDate(new Date())
// import vehicleService from '@/api/VehicleService';
// import * as L from 'leaflet';
import moment from "moment-timezone";
// import { HubConnectionBuilder } from "@microsoft/signalr";
import GPSSerivice from '@/api/GPSSerivice';
import { notify, notifyError, notifyWarn } from '@/utils/notification-helper';
// import { mapIcons } from "@/utils/icons";
import { MAP_MARKER_MOVE_INTERVAL, MESSAGES, TAB_TYPES, TRACKING_TYPE } from '@/utils/constants';
import { ensureLocationInNubmer, getIconByStatus, VEHICLE_STATUS, GEOFENCING_TYPES, createLocationsProp, getStoppageIcon, GEOFENCE, angleFromCoordinate, ensureVehicleProperties } from '@/utils/map/mapUtils';
import mapService from '@/api/mapService';
import vehicleTypeService from "@/api/vehicleTypeService";
import { getColorBySpeed } from "@/utils/map/speedUtils";
import {IMMOBILIZE_STATUS} from '@/utils/constants';
// import { MAP_MARKER_MOVE_INTERVAL } from '@/utils/constants';
// const connection = new HubConnectionBuilder()
// .withUrl("https://novgpsapi.novigodemo.com/SignalHub/", {
// .withUrl("http://localhost:5000/shapeHub/", {
// skipNegotiation: true,
// transport: HttpTransportType.WebSockets
// })
// .build();

const state = {
  mode: TRACKING_TYPE.LIVE,
  geofenceStatus: GEOFENCE.ALL,
  vehicles: [],
  selectedStatus: VEHICLE_STATUS.ALL,
  searchText: '',
  connection: null,
  selectedVehicle: null,
  historyPathOfViewVehicle: {
    polylinesData: [],
    latLonArray: [],
    color: "red"
  },
  center: null,
  vehicleHistory: [],
  vehicleHistoryTransition: [],//Used for playback
  historyStartingPosition: {},
  historyEndingPosition: {},
  currentProgress: 0,
  shareLink: {},
  vehicleTypes: [],
  loader: false,
  startFlagPosition: [],
  endFlagPosition: [],
  vehicleWidgetSettingsArray: [
    {
      field: 'todaysActivity',
      title: 'Todays Activity',
      value: true,
      childrens: [
        { field: 'distance', title: "Distance", value: true },
        { field: 'running', title: "Running", value: true },
        { field: 'stop', title: "Stop", value: true },
        { field: 'inactive', title: "Inactive", value: true },
        { field: 'idle', title: "Idle", value: true },
      ]
    },
    {
      field: 'location',
      title: 'Location',
      value: true,
      childrens: []
    },
    {
      field: 'fuel',
      title: 'Fuel',
      value: true,
      childrens: [
        { field: 'available', title: "Available", value: true },
        { field: 'refuel', title: "Refuel", value: true },
        { field: 'drain', title: "Drain", value: true },
        { field: 'waste', title: "Waste", value: true },
        { field: 'idle', title: "Idle", value: true },
      ]
    },
    {
      field: 'speed',
      title: 'Speed',
      value: true,
      childrens: [
        { field: 'averageSpeed', title: "Average Speed", value: true },
        { field: 'maxSpeed', title: "Max Speed", value: true },
      ]
    },
  ],
  zoom: null,
  geofencingData: null,
  selectedGeofence: null,
  geofenceSearchText: "",
  stoppageLimit: 0,
  selectedTab: TAB_TYPES.VEHICLES,
  immobilize:[],
}
const getters = {
  getVehicles: (state, getters, rootState) => rootState.vehicles,
  getAllVehicles: (state, getters, rootState) => rootState.vehicles,
  getVehiclesFromRoot: (state, getters, rootState) => rootState.vehicles,
  getVehicleTypes: (state, getters, rootState) => rootState.vehicleTypes,
  getSelectedStatus: (state) => state.selectedStatus,
  getSearchText: (state) => state.searchText,
  getVehicleWidgetSettings: (state) => state.vehicleWidgetSettings,
  getWidgetSetting: (state) => (widget) => {
    if(JSON.parse(localStorage.getItem("vehicleWidget"))) {
     return JSON.parse(localStorage.getItem("vehicleWidget")).find((setting) => setting.field === widget);
    }
    return state.vehicleWidgetSettingsArray.find(
      (setting) => setting.field === widget
    );
  },
  getWidgetChildrenSetting: (state) => (widget, children) => {
    if(JSON.parse(localStorage.getItem("vehicleWidget"))) {
    const tempwidgetSetting =JSON.parse(localStorage.getItem("vehicleWidget")).find((setting) => setting.field === widget);
    return tempwidgetSetting.childrens.find(
      (child) => child.field === children
    );
    }
    const widgetSetting = state.vehicleWidgetSettingsArray.find(
      (setting) => setting.field === widget
    );
    return widgetSetting.childrens.find(
      (child) => child.field === children
    );
  },
  activeVehicles: (state, getters) => getters.getVehiclesFromRoot.filter(v => v.status == VEHICLE_STATUS.ACTIVE),
  stoppedVehicles: (state, getters) => getters.getVehiclesFromRoot.filter(v => v.status == VEHICLE_STATUS.STOPPED),
  inactiveVehicles: (state, getters) => getters.getVehiclesFromRoot.filter(v => v.status == VEHICLE_STATUS.INATCTIVE),
  idleVehicles: (state, getters) => getters.getVehiclesFromRoot.filter(v => v.status == VEHICLE_STATUS.IDLE),
  noSignalVehicles: (state, getters) => getters.getVehiclesFromRoot.filter(v => v.status == VEHICLE_STATUS.NO_SIGNAL),
  getVehiclesCount: (state, getters, rootState) => {
    return {
      all: rootState.vehicles.length,
      active: getters.activeVehicles.length,
      inactive: getters.inactiveVehicles.length,
      stopped: getters.stoppedVehicles.length,
      idle: getters.idleVehicles.length,
      nosignal: getters.noSignalVehicles.length
    }
  },
  getVehiclesWithLocationData: (state, getters) => getters.filteredVehicles.filter(v => v.lat && v.lng),
  getHistoryVehicleMarker: (state) => state.selectedVehicle && state.selectedVehicle.lat && state.selectedVehicle.lng ? [state.selectedVehicle] : getters.getVehiclesWithLocationData,
  getLiveVehicleMarker: (state, getters) => state.selectedVehicle && state.selectedVehicle.lat && state.selectedVehicle.lng ? getters.getVehiclesWithLocationData.filter((vh) => vh.deviceid == state.selectedVehicle.deviceid) : getters.getVehiclesWithLocationData,
  getMarkers: (state, getters) => state.selectedTab === TAB_TYPES.VEHICLES ? state.mode == TRACKING_TYPE.LIVE ? getters.getLiveVehicleMarker : getters.getHistoryVehicleMarker : [],
  getPolyLines: (state) => state.mode == TRACKING_TYPE.HISTORY ? state.vehicleHistory : [],
  isHistoryPlaying: (state) => state.mode == TRACKING_TYPE.HISTORY_PLAYING,
  getVehiclesFilteredByMode: (state, getters, rootState) => {
    return state.selectedStatus == VEHICLE_STATUS.ALL ? rootState.vehicles.filter(v => v.status != undefined) : rootState.vehicles.filter(vehicle => vehicle.status === state.selectedStatus)
  },
  filteredVehicles: (state, getters) => getters.getVehiclesFilteredByMode.filter((vehicle) => vehicle.rtoNumber.toUpperCase().includes(state.searchText.toUpperCase())
    || (vehicle.imei && vehicle.imei.toUpperCase().includes(state.searchText.toUpperCase()))),
  getCenter: (state, getters, rootState, rootGetters) => state.selectedVehicle && state.selectedVehicle.lat && state.selectedVehicle.lng ? { ...state.selectedVehicle } : state.center ? state.center : rootGetters.getCenterAndZoom.center,
  getZoom: (state, getters, rootState, rootGetters) => state.zoom || rootGetters.getCenterAndZoom.zoom,
  getRawGeofencingArray: (state, getters) => {
    if (!state.geofencingData) return null;
    if (!getters.getGeofenceSearchText) return state.geofencingData;
    return state.geofencingData.filter((geo) => geo.metadata.geofence.properties.geofenceName.toLowerCase().includes(getters.getGeofenceSearchText.toLowerCase()));
  },
  getSelectedGeofence: (state) => state.selectedGeofence,
  getFilteredGeofenceArray: (state, getters) => {
    if (!getters.getRawGeofencingArray) {
      return null;
    }
    if (getters.getSelectedGeofence) {
      return getters.getRawGeofencingArray.filter((geo) => geo.metadata.geofence.properties.id === getters.getSelectedGeofence.metadata.geofence.properties.id);
    } else if (state.geofenceStatus === GEOFENCE.CITY) {
      return getters.getRawGeofencingArray.filter((geo) => geo.metadata.geofence.properties.geofenceType === GEOFENCE.CITY);
    } else if (state.geofenceStatus === GEOFENCE.GEOFENCE) {
      return getters.getRawGeofencingArray.filter((geo) => geo.metadata.geofence.properties.geofenceType === GEOFENCE.GEOFENCE);
    } else {
      return getters.getRawGeofencingArray
    }
  },
  getGeofencesList: (state, getters) => {
    if(getters.getRawGeofencingArray) {
    if (state.geofenceStatus === GEOFENCE.CITY) {
      return getters.getRawGeofencingArray.filter((geo) => geo.metadata.geofence.properties.geofenceType === GEOFENCE.CITY);
    } else if (state.geofenceStatus === GEOFENCE.GEOFENCE) {
      return getters.getRawGeofencingArray.filter((geo) => geo.metadata.geofence.properties.geofenceType === GEOFENCE.GEOFENCE);
    } else {
      return getters.getRawGeofencingArray
    }
  }
  },
  getGeofenceSearchText: (state) => state.geofenceSearchText,
  getPoints: (state) => (id) => {
    if (state.geofencingData && id) {
      const obj = state.geofencingData.find((geo) => geo.id === id);
      const { geometry, properties } = obj.metadata.geofence;
      switch (properties.type) {
        case GEOFENCING_TYPES.CIRCLE:
          return `${geometry.coordinates.join(" ")} | ${properties.radius}`;
        default:
          return null;
      }
    } else {
      return null;
    }
  },
  getVehiclesHavingIMEINumbers: (state, getters) => {
    return getters.getVehiclesFromRoot.filter((v) => v.imei ? true : false);
  },
  getStoppageMarkers: (state) => {
    return state.mode == TRACKING_TYPE.HISTORY ? state.vehicleHistory.filter(history => history.isStopped).filter(x => x.stopDuration >= state.stoppageLimit * 60)
      .map(x => {
        return { ...x.latLngArray[1], icon: getStoppageIcon(x.stopCount) };
      }) : [];//TODO show stoppages greater than x minutes
  },
  getVehicleSearchText: (state) => state.searchText,
  getMapConnectionStatus: (state, getters,rootState, rootGetters) => rootGetters.getMapStateConnections,
}

const actions = {
  async fetchVehicles({ dispatch, rootState }) {
    //const vehiclesResponse = await vehicleService.getVehicle();
    const ERROR_MSG = 'ZERO_RECORDS';
    let count = 0;
    try {
      if (rootState.vehicles.length === 0) {
        throw Error(ERROR_MSG);
      }
      // const result = rootState.vehicles.filter(v => !!v.imei).map(v => {
      //   // return { ...v, status: VEHICLE_STATUS.NO_SIGNAL, };
      //   return { ...v };
      // });
      // commit('setVehicles', rootState.vehicles);
      // await dispatch('trackVehicles');
    } catch (err) {
      if (err.message === ERROR_MSG && count < 3) {
        setTimeout(function () {
          count++;
          dispatch('fetchVehicles');
        }, 1000);
      } else {
        console.error('ERROR While fetching vehicles ', err);
      }
    }
  },
  async trackVehicles({ state, commit }, data) {
    try {
      commit('updateVehicle', ensureLocationInNubmer(data));
      //LIVE Tracking
      if (state.selectedVehicle && state.selectedVehicle.deviceid == data.deviceid && state.mode == TRACKING_TYPE.LIVE) {
        commit('setSelectedVehicle', { ...state.selectedVehicle, ...data });
      }
    } catch (err) {
      console.log('--------------> ', err)
    }
  },
  // async trackVehicles({ state, commit }) {
  //   try {
  //     await connection.start();
  //     let ids = [];
  //     state.vehicles.forEach((v) => {
  //       if (v.imei && !ids.includes(v.imei)) {
  //         ids.push(v.imei);
  //       }
  //     });
  //     const deviceData = { connectionId: "0", Device_Imei: ids };
  //     connection.on("getLiveTrackingData", function (data) {
  //       commit('updateVehicle', ensureLocationInNubmer(data));
  //       //LIVE Tracking
  //       if (state.selectedVehicle && state.selectedVehicle.deviceid == data.deviceid && state.mode == TRACKING_TYPE.LIVE) {
  //         commit('setSelectedVehicle', { ...state.selectedVehicle, ...data });
  //       }
  //     });
  //     await connection
  //       .invoke("Subscribe", deviceData);
  //     await connection.invoke("getAllData").then(() => console.log('invoked')).catch(er => console.log('invoke error', er));
  //     commit('setConnection', connection);
  //   } catch (err) {
  //     console.log('--------------> ', err)
  //   }
  // },
  // async setDeviceDataToVehicles({ commit, state }, data) {
  //   const styles = {
  //     iconSize: [40, 51],
  //     iconAnchor: [12, 41],
  //     popupAnchor: [10, -20],
  //     shadowSize: [41, 41],
  //   }
  //   let newVehicles = state.vehicles.map(vehicle => {
  //     if (vehicle.imei === data.deviceid) {
  //       let props = {};
  //       // if (data.idle) props.statusText = "idle";
  //       // if (data.status) props.statusText = "active";
  //       // else if (!data.status && !props.statusText) props.statusText = "inactive";
  //       if (data.status === 'Idle') props.statusText = 'idle';
  //       else if (data.status === 'Stopped') props.statusText = 'stopped';
  //       else if (data.status === 'Inactive') props.statusText = 'inactive';
  //       else props.statusText = 'active';

  //       // let icon = null;
  //       switch (props.statusText) {
  //         case 'active':
  //           props.icon = new L.Icon({
  //             ...styles,
  //             iconUrl: mapIcons.carGreen,
  //           })
  //           break;
  //         case 'inactive':
  //           props.icon = new L.Icon({
  //             ...styles,
  //             iconUrl: mapIcons.carGrey,
  //           })
  //           break;
  //         case 'idle':
  //           props.icon = new L.Icon({
  //             ...styles,
  //             iconUrl: mapIcons.carOrange,
  //           })
  //           break;
  //         case 'stopped':
  //           props.icon = new L.Icon({
  //             ...styles,
  //             iconUrl: mapIcons.carRed,
  //           })
  //           break;
  //         default: break;
  //       }

  //       return { ...vehicle, ...data, ...props, latLng: [data.lat, data.lon], lng: data.lon };
  //     }
  //     else return { ...vehicle };
  //   });
  //   commit("setDeviceDataToVehicles", newVehicles);
  //   return;
  // },
  async getHistoryRoutesTravelledByVehicle({ commit, state }, filters) {
    try {


      commit('setLoader', true);
      const constraints = {
        from: moment(filters.from).toISOString(),
        to: moment(filters.to).toISOString(),
        imei: state.selectedVehicle.imei,
      }
      const response = await GPSSerivice.getGPSData(constraints);
      if (response.data.length <= 0) {
        return notifyWarn('No Records Found!');
      }
      commit('setMode', TRACKING_TYPE.HISTORY);
      let polyLines = response.data.map((location, index) => {
        let nextLocation = response.data[index + 1] ? ensureLocationInNubmer(response.data[index + 1]) : ensureLocationInNubmer(location);//For the last pair
        nextLocation = ensureVehicleProperties(nextLocation, state.selectedVehicle);
        return {
          color: getColorBySpeed(nextLocation),
          latLngArray: [location, nextLocation],
          isStopped: nextLocation.isStopped,
          stopCount: nextLocation.stopCount,
          stopDuration: nextLocation.stopDuration
        };
      });
      let vehicle = state.selectedVehicle;
      let newLocation = ensureLocationInNubmer(response.data[0]);
      commit('setCenter', newLocation);
      commit('setSelectedVehicle', { ...vehicle, ...newLocation, lineColor: null, showPolyLine: false, duration: 100, });
      commit("setHistory", polyLines);
      commit("setStartAndEndFlagPosition", polyLines);
    } catch (e) {
      console.warn(e);
    } finally {
      commit('setLoader', false);
    }

  },
  async nextHistoryFrame({ commit, state }, speed) {

    if (state.mode !== TRACKING_TYPE.HISTORY_PLAYING || state.currentProgress >= state.vehicleHistory.length) {
      return;
    }

    let curLocation = state.vehicleHistory[state.currentProgress].latLngArray[1];
    let vehicleDetails = {
      ...state.selectedVehicle,
      ...curLocation,
      latLng: [curLocation.lat, curLocation.lng],
      duration: speed,
      showPolyLine: true,
      lineColor: getColorBySpeed(curLocation),
      iconUrl: getIconByStatus(state.selectedVehicle.status, state.selectedVehicle.type),
      dir: angleFromCoordinate(state.selectedVehicle.lat, state.selectedVehicle.lng, curLocation.lat, curLocation.lng),
    } //TODO Icon and line color changes

    commit('nextHistoryFrame', vehicleDetails);

    if (state.currentProgress <= 1) {
      commit('setEndFlagPostion', null);
    }
    if (state.currentProgress === state.vehicleHistory.length) {
      commit('setEndFlagPostion', state.vehicleHistory);
    }
  },
  async createShareLink({ commit, getters}, data) {
    if (data.vehicles.length === 0) {
      notifyError('No Vehicles Selected to Generate a link');
      return false;
    }
    if (!data.toDate) {
      notifyError(MESSAGES.INVALID_DATE);
      return false;
    }
    if (!data.fromDate) {
      notifyError(MESSAGES.INVALID_DATE);
      return false;
    }
    let toDate = moment(data.toDate),
      fromDate = moment(data.fromDate);
    let selectedVehicles = []
    try {
      getters.getVehiclesFromRoot.map((v) => {
        if (data.vehicles.includes(v.id) && v.imei) {
          //const type = state.vehicleTypes.find((vt) => vt.id === v.vehicleType);
          selectedVehicles.push({
            id: v.id,
            imei: v.imei,
            vehicleType: v.type,
            VehicleMetaData: {
              rtoNumber: v.rtoNumber
            }
          });
        }
      });
    } catch (error) {
      console.error(error);
      if (error.message.includes("Cannot read property 'type' of undefined"))
        notifyError('Make sure that selected Vehicle is having Vehicle Type');
      else
        notifyError(MESSAGES.SOMETHING_WENT_WRONG);
      return false;
    }
    const payload = {
      validFrom: fromDate.utc(),
      validTo: toDate.utc(),
      createdOn: moment.utc(),
      vehicleDetails: selectedVehicles,
    }
    // if (toDate.valueOf() < payload.validFrom.valueOf()) {
    //   notifyError(MESSAGES.TILL_DATE_SHOULD_NOT_BE_GREATER);
    //   return false;
    // }
    try {
      commit('setLoader', true);
      const response = await mapService.createShareLink(payload);
      if (response.data.status) {
        commit('setShareLink', response.data.result);
      }
      commit('setLoader', false);
      return response.data;
    } catch (error) {
      commit('setLoader', false);
    }
  },
  async fetchVehicleTypes({ commit }) {
    const response = await vehicleTypeService.getAllVehicleTypes();
    const sortedResult = response.data.result.sort((a, b) => a.createdAt - b.createdAt);
    commit('setVehicleTypes', sortedResult);
  },
  clearHistoryTimers({ getters, commit }) {
    commit('clearHistoryTimers', getters.getVehiclesFromRoot);
  },
  async fetchGeofenceData({ commit,rootState }) {
    if(!rootState.fileUploadChannelKey){
      return
    }
    let channelKey = rootState.fileUploadChannelKey
    const res = await mapService.fetchGeofencingData(channelKey);
    const moveIdInsideProperties = res.data.result.map((g) => {
      return {
        ...g,
        metadata: {
          ...g.metadata,
          geofence: {
            ...g.metadata.geofence,
            properties: {
              ...g.metadata.geofence.properties,
              id: g.id
            }
          }
        }
      }
    });
     
    console.log("moveIdInsideProperties",moveIdInsideProperties)
    //TODO remove this once sorting is implemented in the backend
    const sortedByCreatedAt = moveIdInsideProperties.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    commit('setGeofencingData', sortedByCreatedAt);
  },
  async saveGeofencing({ commit ,rootState}, data) {
    console.log("datav",data)
    if(!rootState.fileUploadChannelKey){
      return
    }
    let channelKey = rootState.fileUploadChannelKey
    // const CHANNEL_ID = ''
    // commit('setGeofencingData', data, { root: true });
    // await mapService.saveGeofencingData(data);
    let location = createLocationsProp(data);

    const payload = {
      ChannelKey:channelKey,
      GeoFenceType: data.properties.type,
      FenceType:"Circle",
      TriggerOn: "exit",
      DeleteOnTrigger: true,
      FenceArea: location,
      MappedGeofence:data.properties.mappedGeofence,
      DisplayInMap: data.properties.displayInMap,
      MappedDevices:[],
      metadata: {
        geofence: data,
      }
    };
    const res = await mapService.createGeofence(payload);
    console.log('Save geofence Response : ', res);
    const { metadata } = res.data.result
    commit('updateGeofencingData', {
      ...res.data.result,
      ...payload, metadata: {
        ...payload.metadata,
        geofence: {
          ...metadata.geofence,
          properties: {
            ...metadata.geofence.properties,
            id: res.data.result.id,
          }
        }
      }
    });
    return res.data.result;
  },
  async removeGeofencing({ commit }, data) {
    let withIds = [],
      withOutIds = [],
      deletingIds = [];
    console.log('Deleteing data : ', data);
    data.features.forEach((ele) => {
      if (ele.properties.id) {
        withIds.push(mapService.removeGeofence(ele.properties.id));
        deletingIds.push(ele.properties.id);
      }
      else {
        const fence = state.geofencingData.find(
          (g) => g.metadata.geofence.properties.uniqueId === ele.properties.uniqueId
        );
        withOutIds.push(mapService.removeGeofence(fence.metadata.geofence.properties.id));
        deletingIds.push(fence.metadata.geofence.properties.id);
      }
    });
    await Promise.all([...withIds, ...withOutIds]);
    commit('removeGeofences', deletingIds);
  },
  async updateGeofence({ commit, dispatch }, data) {
    
    console.log('Updating geofence :  ', data);
    const array = data.collection.features.map((data) => {
      let location = createLocationsProp(data);
      const payload = {
        id: data.properties.id,
        fenceType: data.properties.type,
        triggerOn: "string",
        deleteOnTrigger: true,
        FenceArea: location,
        metadata: {
          geofence: data,
        }
      };
      return payload;
    });
    console.log('PAYLOAD ARRAY ', array);
    const promises = array.map((a) => mapService.updateGeofence(a));
    try {
      await Promise.all(promises);
    } catch (error) {
      console.error('Error While Updating..', error);
    } finally {
      data.removeLayers();
      dispatch('fetchGeofenceData');
    }

    // data.collection.features 
    // const response = await mapService.updateGeofence(data);
    commit('updateGeofence', data);
  },
  async updateScheduleTime({ commit }, obj) {
    console.log("obj",obj)
    await mapService.updateGeofence({
      ...obj.data,
      metadata: {
        ...obj.data.metadata,
        geofence: {
          ...obj.data.metadata.geofence,
          properties: {
            ...obj.data.metadata.geofence.properties,
            [obj.type]: obj.value,
          }
        }
      }
    });
    console.log("---------->",obj)
    commit('setScheduleTime', obj);
  },
  async updateGeofenceInfo({ commit }, objVal) {
    console.log("object--->",objVal)
    let obj = objVal.data
    const payload = {
      Id:obj.id,
      ChannelKey:obj.channelKey,
      GeoFenceType: obj.geoFenceType,
      FenceType:obj.fenceType,
      TriggerOn: obj.triggerOn,
      DeleteOnTrigger: obj.deleteOnTrigger,
      FenceArea: obj.fenceArea,
      MappedGeofence:obj.mappedGeofence,
      DisplayInMap: obj.displayInMap,
      MappedDevices:obj.mappedDevices,
      metadata: obj.metadata
    };
    await mapService.updateGeofence(payload);
    commit('setUpdateGeofenceInfo', objVal);
  },
  async addVehiclesToGeofence({ dispatch }, data) {
    console.log('ADDING VEHICLE TO GEOFENCEs', data);
    const imeis = data.vehicles.map((v) => v.imei);
    // const { scheduleFromTime, scheduleToTime } = data.geofence.metadata.geofence.properties;
    const payload = {
      GeofenceID: data.geofence.id,
      Devices : imeis,
      // scheduleFromTime: scheduleFromTime,
      // scheduleToTime: scheduleToTime,
      // mobileNumber: "string",
      // emailId: "string",
      // triggerOn: "string",
      // isSMSService: true,
      // isEmailService: true,
      // isCustomSMS: true,
      // isDeleted: false,
    }
    const result = await mapService.addVehiclesToGeofence(payload);
    console.log('Result : ', result);
    notify('Assigned successfully')
    dispatch('fetchGeofenceData');
  },
  async removeVehicleFromGeofence({ commit }, data) {
    console.log('Removing vehicle from geofence : ', data);
    try {
      const result = await mapService.removeVehicleFromGeofence(data);
      commit('removeVehicleFromGeofence', result.data.result);
      console.log('RESULT IS : ', result);
      notify('Removed!');
      return result;
    } catch (error) {
      notifyError(error.message);
    }
  },
  async immobilize({ commit }, data){
    console.log(data);
    let payload={
      IMEI:data.imei,
      CommandKey:"Immobilize",
      CommandValue:"Stop" ,
      Source:"VTS"
    }
  if([IMMOBILIZE_STATUS.STOPPED,null].indexOf(data.immobilizeStatus)!==-1){
      payload.CommandValue ='Stop'
  }
  else{
    payload.CommandValue ='Resuming'
  }
    const result = await mapService.immbolizeVehicle(payload);
    commit('setImmobilizedVehicle', result.data.result);    
  }
}

const mutations = {
  setMode(state, mode) {
    state.mode = mode;
  },
  setVehicles(state, data) {
    state.vehicles = data;
  },
  setSelectedStatus(state, status) {
    if (state.setSelectedStatus != status) {
      state.selectedStatus = status;
      state.selectedVehicle = null;
    }


  },
  setSearchText(state, { target }) {
    state.searchText = target.value;
  },

  updateVehicle(state, vehicle) {
    if (vehicle) {
      state.vehicles = state.vehicles.map(v => {
        if (v.imei == vehicle.deviceid) {
          if (vehicle.status == VEHICLE_STATUS.ACTIVE) {
            console.table({ now: new Date().toString(), lastRefreshed: v.lastRefreshed ? v.lastRefreshed.toString() : "", lat: v.lat + " --> " + vehicle.lat, lng: v.lng + " --> " + vehicle.lng, deviceid: vehicle.deviceid, rotation: vehicle.dir });
          }

          return { ...v, ...vehicle, duration: MAP_MARKER_MOVE_INTERVAL, iconUrl: getIconByStatus(vehicle.status, v.type), lastRefreshed: new Date() }
        } else {
          return v;
        }
      });
    }
  },
  setVehicleWidgetSettings(state, data) {
    state.vehicleWidgetSettings = data;
  },
  setVehicleWidgetConfig(state) {
    if(JSON.parse(localStorage.getItem("vehicleWidget"))) {
     state.vehicleWidgetSettingsArray = JSON.parse(localStorage.getItem("vehicleWidget"));
    }
    },
  setConnection(state, connection) {
    state.connection = connection;
  },
  setSelectedVehicle(state, vehicle) {
    state.vehicles.map((v) => v.selected = false); // unselecting all previous selected vehicles
    if (vehicle) vehicle.selected = true;
    state.selectedVehicle = vehicle;
    if (vehicle == null) {
      state.searchText = "";
      state.zoom = 1;
      state.zoom = 8;
    }
  },
  setHistory(state, polyLines) {
    if (state.selectedVehicle) {
      state.vehicleHistory = polyLines;
      state.currentProgress = 0;
    } else {
      state.vehicleHistory = null;
      state.currentProgress = 0;
    }

  },
  setStartAndEndFlagPosition(state, polyLines) {
    if (polyLines && state.selectedVehicle) {
      state.startFlagPosition = [parseFloat(polyLines[0].latLngArray[0].lat), parseFloat(polyLines[0].latLngArray[0].lng)];
      state.endFlagPosition = [parseFloat(polyLines[polyLines.length - 1].latLngArray[1].lat), parseFloat(polyLines[polyLines.length - 1].latLngArray[1].lng)];
    } else {
      state.startFlagPosition = [];
      state.endFlagPosition = [];
    }
  },
  setEndFlagPostion(state, polyLines) {
    if (polyLines && state.selectedVehicle) {
      state.endFlagPosition = [parseFloat(polyLines[polyLines.length - 1].latLngArray[1].lat), parseFloat(polyLines[polyLines.length - 1].latLngArray[1].lng)];
    } else {
      state.endFlagPosition = [];
    }
  },
  resetSelectionCheckboxes(state, value = false) {
    state.vehicles.map((v) => v.selected = value);
  },

  addToHistoryTransition(state, data) {
    state.vehicleHistoryTransition = [...state.vehicleHistoryTransition, data];
  },
  setCenter(state, center) {
    state.center = center;
  },
  nextHistoryFrame(state, vehicle) {
    state.currentProgress = state.currentProgress + 1;
    state.selectedVehicle = vehicle;
  },
  clearHistoryTimers(state, vehicles) {
    state.currentProgress = 0;
    if (state.selectedVehicle) {
      let currentVehicle = vehicles.find(veh => veh.deviceid == state.selectedVehicle.deviceid);
      state.selectedVehicle = { ...currentVehicle, showPolyLine: false, duration: 0 };
    }
    state.mode = TRACKING_TYPE.LIVE;
  },
  setShareLink(state, shareLink) {
    state.shareLink = shareLink;
  },
  setVehicleTypes(state, data) {
    state.vehicleTypes = data;
  },
  setLoader(state, value) {
    state.loader = value;
  },
  setZoom(state, zoom) {
    state.zoom = zoom;
  },
  setGeofencingData(state, data) {
    console.log("dataa----->",data)
    state.geofencingData = data;
  },
  updateGeofencingData(state, data) {
    if (state.geofencingData) {
      state.geofencingData.push(data);
    } else {
      state.geofencingData = [data];
    }
  },
  removeGeofences(state, arr) {
    state.geofencingData = state.geofencingData.filter((g) => !arr.includes(g.id));
  },
  setSelectedGeofence(state, fence) {
    state.selectedGeofence = fence;
  },
  setGeofenceSearchText(state, text) {
    state.geofenceSearchText = text;
    console.log("#geofence",state.geofenceSearchText)
  },
  setScheduleTime(state, obj) {
    console.log('Under construction ', obj);
    state.geofencingData.map((geo) => {
      if (geo.id === obj.data.id) {
        geo.metadata.geofence.properties[obj.type] = moment.utc(obj.value).format();
        console.log('#DATA updated ', geo.metadata.geofence.properties);
      }
    });
  },
  updateGeofence(state, obj) {
    console.log('Update geofence...', obj);
    // const index = state.geofencingData.findIndex((geo) => geo.id === obj.id);
    // state.geofencingData.splice(index, 1, obj);
  },
  setStoppageLimit(state, limit) {
    state.stoppageLimit = limit;
  },
  setSelectedTabInStore(state, tabName) {
    state.selectedTab = tabName;
  },
  removeVehicleFromGeofence(state, data) {
    const geofence = state.geofencingData.find((geo) => geo.id === data.id);
    geofence.mappedDevices = data.mappedDevices
    console.log("geofence",geofence)
    // if (geofence.mappedDevices) {
    //   geofence.mappedDevices = geofence.mappedDevices.filter(
    //     (vd) => vd.imei !== data.imei
    //   );
    // }

    // [1, 2, 3, 4].filter(
//     function(e) {
//       return this.indexOf(e) < 0;
//     },
//     [2, 4]
// );
  },
  setGeofenceStatus(state, status) {
    state.geofenceStatus = status;
  },
  setUpdateGeofenceInfo(state, obj) {
    state.geofencingData.map((geo) => {
      if (geo.id === obj.data.id) {
        geo.metadata.geofence.properties[obj.type] = obj.value;
      }
    });
  },
  setImmobilizedVehicle(state,data){
    state.immobilize=data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}